import { useCallback } from 'react';
import { useToastProgress } from 'App/components/ToastProgressContext';
import { useToast } from 'commons/hooks';
import useTranslationFulfillmentOrders from 'domains/FulfillmentOrders/useTranslationFulfillmentOrders';

interface UseActionsToastResult {
  onErrorPrintManager: () => void;
  onSuccessPrintManager: () => void;
  onTimeoutPrintManager: () => void;
}

function useActionsToast(): UseActionsToastResult {
  const t = useTranslationFulfillmentOrders();
  const { addToast } = useToast();
  const { closeToastProgress } = useToastProgress();

  const onErrorPrintManager = useCallback(() => {
    closeToastProgress();
    addToast({
      label: t('printManager.actionError'),
      appearance: 'danger',
    });
  }, [closeToastProgress, addToast, t]);

  const onSuccessPrintManager = useCallback(() => {
    closeToastProgress();
    addToast({
      label: t('printManager.actionSuccess'),
      appearance: 'success',
    });
  }, [closeToastProgress, addToast, t]);

  const onTimeoutPrintManager = useCallback(() => {
    closeToastProgress();
    addToast({
      label: t('printManager.asyncTimeout'),
      appearance: 'danger',
    });
  }, [closeToastProgress, addToast, t]);

  return {
    onErrorPrintManager,
    onSuccessPrintManager,
    onTimeoutPrintManager,
  };
}

export default useActionsToast;
